import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative w-full min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <MediaSection />
        <CommentsSection />
        <FeaturesSection />
        <CarouselSection />
        <ContactSection />
        <UpdatesSection />
        <IndexSection />
        <TopicsSection />
        <RankingSection />
        <AppSection />
        <CardsSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}